const initailState = {
    helplinedata:[]
  };
  
  export function helplineReducer(state = initailState, { type, payload }) {
  
    switch (type) {
      case "HELPLINE":
        return { ...state ,helplinedata:payload};
  
      default:
        return state;
    }
  }